<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" style="width:100%;">
          <h3>Calls</h3>
          <div class="d-flex align-center">
            <v-icon @click="clear" class="mr-2">mdi-close</v-icon>
            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFrom"
                  label="From"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  style="width:150px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="pickerFrom"
                v-model="dateFrom"
                :max="new Date().toISOString().substr(0, 10) + 1"
                min="1950-01-01"
              ></v-date-picker>
            </v-menu>

            <v-menu
              ref="menuTo"
              v-model="menuTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateTo"
                  label="To"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="ml-2"
                  style="width:150px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="pickerTo"
                v-model="dateTo"
                :max="new Date().toISOString().substr(0, 10) + 1"
                min="1950-01-01"
              ></v-date-picker>
            </v-menu>

            <v-text-field
              class="ml-2"
              v-model="overTimeSec"
              label="At least (sec)"
              style="width:150px;"
              type="number"
            ></v-text-field>
            <v-btn rounded text @click="filter" class="text-capitalize ml-2">
              <p class="mb-0" style="color:rgb(0,170,221)">search</p>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="data"
          :loading="loading"
        >
          <template
            v-slot:item.connectedCalls=" { item }"
          >{{item.connectedCalls + ' ('+percentage(item.connectedCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.notConnectedCalls=" { item }"
          >{{item.notConnectedCalls + ' ('+percentage(item.notConnectedCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.cancelledCalls=" { item }"
          >{{item.cancelledCalls + ' ('+percentage(item.cancelledCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.declinedCalls=" { item }"
          >{{item.declinedCalls + ' ('+percentage(item.declinedCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.timedOutCalls=" { item }"
          >{{item.timedOutCalls + ' ('+percentage(item.timedOutCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.notEndedCalls=" { item }"
          >{{item.notEndedCalls + ' ('+percentage(item.notEndedCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.completedCalls=" { item }"
          >{{item.completedCalls + ' ('+percentage(item.completedCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.overTimeCalls=" { item }"
          >{{item.overTimeCalls + ' ('+percentage(item.overTimeCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.underTimeVideoCalls=" { item }"
          >{{item.underTimeVideoCalls + ' ('+percentage(item.underTimeVideoCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.rateUrgentCalls=" { item }"
          >{{item.rateUrgentCalls + ' ('+percentage(item.rateUrgentCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.rateUsefulCalls=" { item }"
          >{{item.rateUsefulCalls + ' ('+percentage(item.rateUsefulCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.rateUselessCalls=" { item }"
          >{{item.rateUselessCalls + ' ('+percentage(item.rateUselessCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.rateNoRatingCalls=" { item }"
          >{{item.rateNoRatingCalls + ' ('+percentage(item.rateNoRatingCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <template
            v-slot:item.endedBySystemCalls=" { item }"
          >{{item.endedBySystemCalls + ' ('+percentage(item.endedBySystemCalls, item.startedInPeriodCalls)+'%)'}}</template>
          <!-- <template v-slot:item.verifiedOn="{ item }">{{ convertDate(item.verifiedOn) }}</template>
          <template v-slot:item.validatedOn="{ item }">{{ convertDate(item.validatedOn) }}</template>
          <template v-slot:item.isPublicDoctor="{item}">
            <v-icon>{{ !!item.isPublicDoctor ? 'mdi-check' : '' }}</v-icon>
          </template>
          <template
            v-slot:item.totalTimeOnCallMin=" { item }"
          >{{!!item.totalTimeOnCallMin ? item.totalTimeOnCallMin : '0' }}</template>
          <template
            v-slot:item.acceptedCallCount=" { item }"
          >{{item.acceptedCallCount + ' ('+percentage(item.acceptedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.declinedCallCount=" { item }"
          >{{item.declinedCallCount + ' ('+percentage(item.declinedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.cancelledCallCount=" { item }"
          >{{item.cancelledCallCount + ' ('+percentage(item.cancelledCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.timedOutCallCount=" { item }"
          >{{item.timedOutCallCount + ' ('+percentage(item.timedOutCallCount, item.invitedCallCount)+'%)'}}</template>-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  created() {
    console.log("xixixi");
    this.loading = true;
    axios
      .get(`${process.env.VUE_APP_BASE_URL}admin/activityInPeriod`)
      .then(res => {
        console.log(res);
        this.loading = false;
        this.data.push(res.data);
        //  this.count = res.data.totalCount;
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
      });
  },

  data() {
    return {
      menuFrom: false,
      menuTo: false,
      loading: false,
      dateFrom: "",
      dateTo: "",
      overTimeSec: "",
      data: [],
      headers: [
        {
          text: "Started",
          value: "startedInPeriodCalls"
        },
        {
          text: "Connected",
          value: "connectedCalls"
        },
        {
          text: "Not connected",
          value: "notConnectedCalls"
        },
        {
          text: "Cancelled",
          value: "cancelledCalls"
        },
        {
          text: "Declined",
          value: "declinedCalls"
        },
        {
          text: "Timed out",
          value: "timedOutCalls"
        },
        {
          text: "Not ended",
          value: "notEndedCalls"
        },
        {
          text: "Completed",
          value: "completedCalls"
        },
        {
          text: "Overtime",
          value: "overTimeCalls"
        },
        {
          text: "Undertime",
          value: "underTimeVideoCalls"
        },
        {
          text: "Urgent",
          value: "rateUrgentCalls"
        },
        {
          text: "Usefull",
          value: "rateUsefulCalls"
        },
        {
          text: "Useless",
          value: "rateUselessCalls"
        },
        {
          text: "No rating",
          value: "rateUselessCalls"
        },
        {
          text: "Ended by System",
          value: "endedBySystemCalls"
        }
      ]
    };
  },

  methods: {
    convertDate(date) {
      return moment(moment.utc(date).toDate())
        .local()
        .format("DD/MM/YYYY");
    },
    percentage(num, per) {
      return Math.floor((num / per) * 100);
    },
    filter() {
      this.data.pop();
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}admin/activityInPeriod?${
            this.dateFrom === "" ? "" : "dateFrom=" + this.dateFrom
          }${this.dateTo === "" ? "" : "&dateTo=" + this.dateTo}${
            this.overTimeSec === "" ? "" : "&overTimeSec=" + this.overTimeSec
          } `
        )
        .then(res => {
          console.log(res);
          this.loading = false;
          this.data.push(res.data);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    clear() {
      this.dateFrom = "";
      this.dateTo = "";
      this.numCalls = "";
      this.filter();
    }
  },
  watch: {
    menuFrom(val) {
      val && setTimeout(() => (this.$refs.pickerFrom.activePicker = "YEAR"));
    },
    menuTo(val) {
      val && setTimeout(() => (this.$refs.pickerTo.activePicker = "YEAR"));
    }
  }
};
</script>